import { render, staticRenderFns } from "./createEdit.vue?vue&type=template&id=66d2d796"
import script from "./createEdit.vue?vue&type=script&lang=js"
export * from "./createEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports